module.exports = __webpack_public_path__ + "static/media/chennai.107cdd94.jpg";